<template lang="pug">
  v-alert(
    v-if="error"
    colored-border
    type="error"
    prominent
    :icon="mdiAlert") {{ error.message }}
  div.text-center.d-none(v-else)
    div.d-inline-block.d-none(ref="container")
</template>

<script>
import Vue from 'vue'
import { ref, onMounted, toRefs, reactive, watch } from '@vue/composition-api'
import { theme } from '@iez/core'
import { mdiAlert } from '@mdi/js'
import firebase from 'firebase/app'

export default {
  props: {
    value: Object,
    phoneNumber: String
  },

  setup (props, { emit }) {
    const container = ref(null)

    const state = reactive({
      loaded: false,
      error: null
    })

    onMounted(() => {
      Vue.nextTick(() => {
        const testsNumber = [
          `+33600000000`,
          `+33611111111`
        ]
        firebase.auth().settings.appVerificationDisabledForTesting = testsNumber.includes(props.phoneNumber)
        const recaptchaVerifier = new firebase.auth.RecaptchaVerifier(container.value, {
          size: 'invisible'
        })
        recaptchaVerifier.render().then(() => {
          emit('input', recaptchaVerifier)
        })
      })
    })

    return {
      container,
      ...toRefs(state),
      theme,
      mdiAlert
    }
  }
}
</script>
